/* eslint-disable max-len */
import React from 'react';

const SpotifyIcon = (props: any) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 0C3.582 0 0 3.582 0 8C0 12.419 3.582 16 8 16C12.418 16 16 12.419 16 8C16 3.582 12.418 0 8 0ZM11.669 11.539C11.525 11.774 11.218 11.849 10.983 11.705C9.104 10.557 6.74 10.297 3.955 10.934C3.688 10.995 3.42 10.827 3.358 10.559C3.297 10.29 3.465 10.022 3.733 9.962C6.781 9.265 9.395 9.564 11.504 10.854C11.738 10.997 11.813 11.304 11.669 11.539ZM12.647 9.36C12.467 9.654 12.083 9.746 11.79 9.565C9.64 8.244 6.361 7.861 3.818 8.634C3.488 8.733 3.14 8.547 3.04 8.218C2.94 7.889 3.126 7.54 3.456 7.44C6.361 6.559 9.974 6.985 12.442 8.503C12.735 8.684 12.828 9.067 12.647 9.36ZM12.732 7.092C10.153 5.561 5.9 5.42 3.438 6.167C3.043 6.287 2.625 6.063 2.505 5.669C2.385 5.273 2.608 4.855 3.004 4.735C5.83 3.877 10.527 4.043 13.496 5.806C13.852 6.017 13.968 6.476 13.758 6.83C13.547 7.187 13.087 7.304 12.732 7.092Z"
      fill="currentColor"
    />
  </svg>
);

export default SpotifyIcon;
